export default class Country {
    constructor({
        id = 0,
        name = '',
        code = '',
        isActive = false,
        createdAt = '',
        updatedAt = '',
    } = {}) {
        this.id = id;
        this.name = name;
        this.code = code;
        this.isActive = isActive;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}
